const report = {
    header: {
        patientName: "Patient's name",
        treatingPhysician: 'Treating physician',
        age: 'Age',
        institute: 'Institute',
        gender: 'Gender',
        tumorset: 'Tumorset',
        molecularTests: 'Molecular test(s)',
        metastasis: 'Metastasis',
        sampleIds: 'Sample ID(s)',
        patientId: 'Patient ID',
        reportId: 'Report ID',
        dateOfReport: 'Date of report'
    },
    summary: {
        title: 'Summary',
        molecularProfile: {
            title: 'Molecular profile',
            alterations: 'Alterations',
            drivers: 'Drivers',
            targets: 'Targets',
            info: 'This is a summary of the most important findings in the molecular profile: the number of molecular alterations detected in the samples and the number of drivers and targets identified by computational analysis. A variant is classified as a driver by having an GBS higher than zero, based on the available matching evidence in the database. The target count comprises directly targetable drivers and indirect target genes associated with driver genes by matching evidence relations in the database.'
        },
        compounds: {
            title: 'Compounds',
            thisTumorType: 'This tumor type',
            otherTumorTypes: 'Other tumor types',
            development: 'Development',
            info: 'This section contains the numbers of compounds associated with the molecular profile grouped by their availability. Full circle denotes compounds registered by FDA/EMA in the patient’s tumor type. Half full circle denotes compounds registered in other tumor types. Empty circle denotes compounds currently available in clinical trials only.'
        },
        possibleTrials: {
            title: 'Possible trials',
            info: 'The number of trials matching the patient’s tumor type, stage and other various factors are shown here.'
        },
        rulesUsed: {
            title: 'Rules used',
            clinical: 'Clinical',
            preclinical: 'Preclinical',
            frequency: 'Frequency',
            inSilico: 'In Silico',
            info: 'The Genomate® MTC assigns Genomate® Biomarker Scores, Genomate® Target Scores and Genomate® Drug Scores and ranks drivers, targets, and compounds based on a complex algorithm using a comprehensive database of evidence relations encoded in the system as rules. The number and type of rules used for the current report are represented here.'
        },
        author: {
            writtenBy: 'Written by'
        },
        gds: {
            title: 'Genomate® scoring method',
            description:
                'Genomate® Drug Score (GDS) corresponds to the previously introduced concept of Aggregated Evidence Level (AEL) of a given compound for the particular tumor molecular profile (Petak et al. NPJ Precis Oncol. 2021;5(1):59). GDS represents the number, scientific impact, and clinical relevance of evidence relations in the system, connecting the drug with tumor types, molecular alterations and targets. Using the same conceptual framework, Genomate® Biomarker Score (GBS) and Genomate® Target Score (GTS) represent AELs for each alteration and each target, respectively. For more details see <1>Petak et al. NPJ Precis Oncol. 2021 5(1):59</1>'
        }
    },
    biomarkersAndInhibitors: {
        reportPageTitle: 'Drivers',
        reportPageSubTitle:
            'Driver alterations and Genomic markers ranked by GBS',
        linkButton: 'See all genes and variants',
        tableHeader: {
            variant: 'Variant',
            driverClassification: 'Classification',
            gbs: 'GBS',
            chevron: ''
        },
        noDriversAndBiomarkersFound:
            'No drivers and biomarkers were found for this patient.'
    },
    detailedAnalysis: {
        openButton: 'Detailed Analysis',
        summary: 'Summary',
        diagnosticTests: 'Pathological and molecular diagnostic tests',
        previousTherapies: 'Previous therapies',
        biomedicalInterpretation: 'Biomedical interpretation'
    },
    expertsInvolved: {
        openButton: 'Experts involved'
    },
    generalErrors: {
        unknown: {
            title: 'Something went wrong',
            description: 'Report could not be loaded from the server.'
        },
        accessDenied: {
            title: 'Access Denied',
            description: 'You have no permission to view this report.'
        }
    },
    download: {
        errors: {
            'validation.report.notFound': 'Report not found'
        }
    }
}

export default report
